import { useEffect, useState } from "react";
import axios from "axios";
import Layout from "../components/Layout";
import { useParams } from "react-router-dom";
import CreatureCard from "../components/CreatureCard";
import ReactMarkdown from "react-markdown";

const Creature = () => {
  const [creatureData, setCreatureData] = useState(false);
  let { creatureid } = useParams(); // Unpacking and retrieve id

  useEffect(() => {
    getCreature();
  }, []);

  const getCreature = () => {
    axios
      .get(
        `https://creatureparty.net/dashboard/wp-json/creatureparty/v1/creatures/${creatureid}`
      )
      .then((res) => setCreatureData(res.data))
      .catch((err) => console.log(err));
  };

  return (
    <Layout>
      <section className="Creature">
        {creatureData ? (
          <div>
            {creatureData.img && (
              <div className="Creature__Image">
                <img src={creatureData.img.large} />
              </div>
            )}

            <h1>{creatureData.name}</h1>
            <div className="Creature__Description">
              <ReactMarkdown children={creatureData.description} />
            </div>
            <p className="Creature__Meta">
              Invited by{" "}
              <a href={`/authors/${creatureData.author.id}`}>
                {creatureData.author.firstName}
              </a>{" "}
              to{" "}
              <a href={`/parties/${creatureData.attended.party_id}`}>
                {creatureData.attended.party}
              </a>{" "}
              on {creatureData.attended.party_date}
            </p>
          </div>
        ) : null}
      </section>
    </Layout>
  );
};

export default Creature;
